const palette = {
  type: "light",
  black: {
    main: "#000000",
  },
  white: {
    main: "#ffffff",
  },
  primary: {
    main: "#1AB21A",
  },
  secondary: {
    main: "#E3E3E8",
  },
  error: {
    main: "#FF0000",
  },
  success: {
    main: "#1EDF0D",
  },
  background: {
    default: "#f9fafb",
    paper: "#FFF",
  },
  text: {
    primary: "#222222",
    secondary: "rgba(34,34,34,0.8)",
    hover: "rgba(34,34,34,0.7)",
    dark: {
      primary: "#ffffff",
      secondary: "rgba(255,255,255,0.85)",
      hover: "rgba(255,255,255,0.6)",
    },
  },
};

export default palette;
